import { render, staticRenderFns } from "./statistique.vue?vue&type=template&id=222f6606"
import script from "./statistique.vue?vue&type=script&lang=js"
export * from "./statistique.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports